﻿export const LANG_SR_CYR_NAME = 'sr_cyr';

export const LANG_SR_CYR_TRANS = {
    'broj_prituzbe': 'Број притужбе',
    'sacuvaj_lokaciju': 'Сачувај локацију',
    'dodaj_dokumenat': 'Додај докуменат',
    'posalji_obavjestenje_o_azuriranju': 'Пошаљи обавјештење о ажурирању',
    'notifikacija_poslata_korisnicima': 'Обавјештење је послато корисницима',
    'preuzmi_upute': 'Преузми упуте',
    'anketar': 'Анкетар',
    "surveysYear1All": "Број завршених анкета у претходној години - локалне",
    "surveysYear2All": "Број завршених анкета у претходне 2 године - локалне",
    "surveysYear3All": "Број завршених анкета у претходне 3 године - локалне",
    "surveysYear1Global": "Број завршених анкета у претходној години - глобалне",
    "surveysYear2Global": "Број завршених анкета у претходне 2 године - глобалне",
    "surveysYear3Global": "Број завршених анкета у претходне 3 године - глобалне",
    "mobileUsers": "Корисници мобилних апликација - креирани налози",
    'statistika_koristenja_eCitizen_aplikacije':'Статистика кориштења eCitizen апликације',
    'usersSum': 'Број корисника - укупно',
    'anonymous': 'Анонимни корисници',
    'registered': 'Регистровани корисници',
    'administrator': 'Администратор',
    'office': 'Службеник',
    'officeModerator': 'Службеник - Модератор',
    'manager': 'Менаџер',
    'orgUnit': 'Организација',
    'councilMember': 'Вијећник',
    'mayor': 'Начелник',
    'institution': 'Установа',
    'service': 'Сервис',
    'complaintsSum': 'Број притужби',
    'complaintsOpenedInTheReportingPeriod': 'Број притужби - Отворене у извјештајном периоду',
    'complaintsResolvedInTheReportingPeriod': 'Број притужби - Ријешене у извјештајном периоду',
    'complaintsOpenedAndResolvedInTheReportingPeriod': 'Број притужби - Отворене и ријешене у извјештајном периоду',
    'complaintsAverageAnswerTimeInTheReportingPeriod': 'Просјечно вријеме одговора (дана) на притужбу у извјештајном периоду',
    'complaintsAverageResolveTimeInTheReportingPeriod': 'Просјечно вријеме (дана) за рјешење на притужбу у извјештајном периоду',
    'questionsTotalAnswersInTheReportingPeriod': 'Број одговора у извјештајном периоду',
    'questionsAverageResponseTimeInTheReportingPeriod': 'Просјечно вријеме одговора (дана) на питање у извјештајном периоду',
    'sessionsTotalNumberOfPointsInTheReportingPeriod': 'Укупан број тачака свих сједница у извјештајном периоду',
    'debatesAverageDurationInTheReportingPeriod': 'Просјечно вријеме трајања (дана) расправе у извјештајном периоду',
    'administrativeProcedures': 'Укупни број управних поступака',
    'questions': 'Број питања',
    'sessions': 'Број сједница',
    'debates': 'Број јавних расправа',
    'demografska_pitanja': 'Демографска питања',
    'podaci_neispravni': 'Унесени подаци нису исправни',
    'pitanje_zavrsavanje_ankete': 'Да ли сте сигурни да желите завршити анкету',
    'potvrda_zavrsavanje_ankete': 'Потврда завршетка анкете',
    'anketa_uspjesno_zavrsena': 'Анкета је успјешно завршена',
    'Pomjeri': 'Помјери',
    'zaustavi_anketu': 'Заврши анкету',
    'min_ispitanika': 'Минимално испитаника',
    'br_usenika': 'Број учесника',
    'Odabir člana vijeća/načelnika/gradonačelnika': 'Одабир члана вијећа/начелника/градоначелника',
    'adm_proc_uspjesno_obrisan': 'Административна процедура успјешно обрисана',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_adm_proc': 'Да ли сте сигурни да желите да обришете административну процедуру',
    'Starosna_struktura_obavezna': 'Старосна структура је обавезна',
    'Podrucje_obavezno': 'Подручје је обавезно',
    'osjetljive_kategorije_obavezno': 'Осјетљива категорија је обавезна',
    'period_nezaposlenosti_obavezan': 'Период незапослености је обавезан',
    'status': 'Статус',
    'zapoceta': 'Започета',
    'nezapoceta': 'Незапочета',
    'zavrsena': 'Завршена',
    "odaberite_period_nezaposlenosti": "Колико дуго сте незапослени?",
    "odaberite_osjetljive_kategorije": "Припадате ли некој од осјетљивих категорија?",
    "period_nezaposlenosti": "Период незапослености",
    "nastavi_kasnije": "Настави касније",
    'detalji_ucesnik': 'Детаљи о учеснику',
    'starosna_struktura': 'Старосна структура',
    'odaberite_podrucje': 'У којој врсти средине станујете?',
    'odaberite_starost': 'Којој старосној групи припадате?',
    'odaberite_pol': 'Који је ваш пол?',
    'Podrucje':'Средина становања',
    'participant_details_instruction': 'Прије покретања анкете потребно је одговорити на следећа питања која се односе на учеснике анкете. Након попуњавања наведених питања анкета ће бити започета',
    'moje_ankete': 'Моје анкете',
    'javne_ankete': 'Јавне анкете',
    'verifikacija_telefona': 'Верификација телефона',
    'uneseni_kod_pogresan': 'Унесени код није исправан',
    'phone_verification_instruction1': 'За покретање анкете неопходно је унијети ветификациони код. Уколико немате код одаберите опцију "Немате код?", или кликните',
    'phone_verification_instruction2': 'овдје',
    'phone_verification_instruction3': ', затим унесите Ваш број телефона, након тога верификациони код биће Вам достављен путем СМС поруке.',
    'Verifikuj': 'Верификуј',
    'nemate_kod': 'Немате код',
    'zapocni': 'Започни',
    'imate_kod': 'Добили сте код',
    'kod_neispravan': 'Код није исправан',
    'Pocetak_vazenja_od':'Почетак важенја од',
    'Pocetak_vazenja_do':'Почетак важенја до',
    'Kraj_vazenja_od':'Крај важенја од',
    'Kraj_vazenja_do':'Крај важенја до',
    'Pocetna': 'Почетна',
    'Hvala_na_ucescu': 'Хвала на учешћу',
    'verifikacioni_kod_nije_poslat_SMS': 'Унесени број је искориштен за изабрану анкету.',
    'verifikacioni_kod_poslat_SMS': 'Верификациони код је успјешно послат СМС-ом.',
    'posalji_kod':'Пошаљи код',
    'ponovno_slanje_je_moguce_za': 'Поновно слање је могуће за',
    'Telefonski_broj_neispravan': 'Телефонски број није исправан',
    'odgovor_nije_popunjen': "Одговор није попуњен",
    'anketa':'Анкета',
    'vazi_do': 'Важи до',
    'popunjeno': 'Попуњено',
    'prethodno': 'Претходно',
    'sledece': 'Сљедеће',
    'pitanje_broj': 'Питање број',
    'odaberite_organizacionu_jedinicu': 'Одаберите организациону јединицу',
    'organizacione_jedinice_pitanja': 'Питања организацијским јединицама',
    'pitanja_za_organizacione_jedinice_detalji': 'Питања постављена организационој јединици',
    'pitanje_brisanje_statusa_ankete': 'Да ли сте сигурни да желите избрисати статус анкете',
    'potvrda_brisanja_statusa_ankete': 'Потврда брисања статуса анкете',
    'uspjesno_obrisan_status_ankete': 'Статус анкете је успјешно обрисан',
    'lista_statusa_anketa': 'Листа статуса анкета',
    'statusi_anketa': 'Статуси анкета',
    'unos_novog_statusa_anketa': 'Унос новог статуса анкета',
    'izmjena_statusa_anketa': 'Измјена статуса анкета',
    'vrste-ucesnika-anketa': 'Врсте учесника анкета',
    'lista-vrsta-ucesnika-anketa': 'Листа врста учесника анкета',
    'izmjena_vrste_ucesnika_ankete': 'Измјена врсте учесника анкете',
    'unos_nove_vrste_ucesnika_ankete': 'Унос врсте учесника анкете',
    'izmjena_tipa_ankete' : 'Измјена типа анкете',
    'unos_novog_tipa_ankete': 'Унос новог типа анкете',
    'uspjesno_obrisana_vrsta_ucesnika_ankete': 'Врста учесника анкете је успијешно обрисана',
    'potvrda_brisanja_vrste_ucesnika_ankete':  'Потврда брисања врсте учесника анкете',
    'pitanje_brisanje_vrste_ucesnika_ankete': 'Да ли сте сигурни да желите избрисати врсту учесника анкете',
    'tipovi-anketa': 'Типови анкета',
    'lista-tipova-anketa': 'Листа типова анкета',
    'pitanje_brisanje_tipa_ankete': 'Да ли сте сигурни да желите избрисати тип анкете',
    'potvrda_brisanja_tipa_ankete': 'Потврда брисања типа анкете',
    'uspjesno_obrisan_tip_ankete': 'Тип анкете је успијешно обрисан',
    'pitanje_brisanje_kategorije_ankete': 'Да ли сте сигури да желите обрисати категорију анкете',
    'potvrda_brisanja_kategorije_ankete': 'Потврда брисања категорије анкете',
    'uspjesno_obrisan_kategorija_ankete': 'Тип анкете је успјешно обрисан',
    "kategorija_anketa": "Категорије анкета",
    "lista_kategorija_anketa": "Листа категорија анкета",
    "izmjena_kategorije_anketa": "Измјена категорија анкета",
    "unos_nove_kategorije_anketa": "Унос нове категорије анкета",
    'pitanje_brisanje_pravnog_lijeka': 'Да ли сте сигурни да желите избрисати правни лијек',
    'potvrda_brisanja_pravnog_lijeka': 'Потврда брисања правног лијека',
    'uspjesno_obrisan_pravni_lijek': 'Правни лијек је успјешно обрисан',
    "Dodaj": "Додај",
    "Naslov": "Наслов",
    "Naziv": "Назив",
    "Tekst": "Текст",
    "Opis": "Опис",
    "Kod": "Код",
    "Redoslijed": "Редослијед",
    "Aktivan": "Активан",
    "PostaviNaVrh": "Постави на врх",
    "Nema_podataka": "Нема података",
    "Da": "Да",
    "Ne": "Не",
    "Spasi": "Сачувај",
    "Odustani": "Одустани",
    "Naziv_dokumenta": "Назив документа",
    "Tip_dokumenta": "Тип документа",
    "Dokument": "Документ",
    "Dodatni_materijali_obavijesti": "Додатни материјали/обавијести",
    "Korisnicko_ime": "Корисничко име",
    "Opcina_Opstina_Grad": "Опћина/Општина/Град",
    "Anonimni_korisnik": "Анонимни корисник",
    "Registrovani_korisnik": "Регистровани корисник",
    "Registrujte_se": "Региструјте се",
    'Lozinka': 'Лозинка',
    'Korisnicko_ime_obavezno': 'Корисничко име је обавезно',
    'Lozinka_obavezna': 'Лозинка је обавезна',
    'Lozinka_obavezna_duzina': 'Лозинка мора бити дужине 8 карактера',
    'Potvrdi_lozinku': 'Потврди лозинку',
    'Obavezna_potvrda_lozinke': 'Потврдите лозинку',
    'Lozinke_se_moraju_podudarati': 'Лозинке се морају подударати',
    'Validacija_naloga': 'Валидација налога',
    'Godina_rodjenja': 'Година рођења',
    'Godina_rodjenja_obavezna': 'Година рођења је обавезна',
    'Ime': 'Име',
    'Ime_obavezno': 'Име је обавезно',
    'Prezime': 'Презиме',
    'Prezime_obavezno': 'Презиме је обавезно',
    'Telefonski_broj': 'Телефонски број',
    'Telefonski_broj_obavezan': 'Телефонски број је обавезан',
    'Telefonski_broj_nije_validan': 'Телефонски број није исправан',
    'Email': 'Емаил',
    'Email_obavezan': 'Емаил је обавезан',
    'Spol': 'Пол',
    'Spol_obavezan': 'Пол је обавезан',
    'Validacija_naloga_obavezna': 'Начин валидације налога је обавезан',
    'Prijavi_se': 'Пријави се',
    'Organizaciona_jedinica': 'Организациона јединица',
    'Organizaciona_jedinica_obavezna': 'Организациона јединица је обавезна',
    'Nadredena_organizaciona_jedinica': 'Надређена организациона јединица',
    'Uredi': 'Уреди',
    'forbidden': 'Забрањено!',
    'dogodila_se_greska': 'Догодила се грешка!',
    'poruka_sistema': 'Порука система: ',
    'sesija_istekla': 'Ваша сесија је истекла, молимо пријавите се поново на систем!',
    'zahtjev_za_web_servis_pogresan': 'Захтјев за wеб сервис није правилно формулисан!',
    'servis_nedostupan': 'Сервис није доступан!',
    'metoda_nije_dozvoljena': 'Метода није дозвољена!',
    'korisnicko_ime_obavezna_duzina': 'Корисничко име мора имати 8 карактера',
    'applicationtypeid_obavezan': 'ApplicationTypeId обавезан',    
    'Naslov_obavezan': 'Наслов је обавезан',
    'Opis_obavezan': 'Опис је обавезан',
    'naziv_dokumenta_obavezan': 'Назив документа је обавезан',
    'nedostaje_ekstenzija': 'Недостаје екстензија документа',
    'tip_dokumenta_obavezan': 'Тип документа обавезан',
    'redoslijed_obavezan': 'Редослијед је обавезан',
    'nedostaje_aktivan': 'Недостаје податак да ли је запис активан',
    'tekst_obavezan': 'Текст је обавезан',
    'naziv_obavezan': 'Назив је обавезан',
    'nije_odabran_jezik': 'Није одабран језик',
    'id_obavezan': 'ИД је обавезан',
    'morate_se_prijaviti_prijava_problema': 'Морате се пријавити на систем да бисте пријавили проблем!',
    'Profil': 'Профил',
    'Profil_obavezan': 'Профил је обавезан',
    'Organizaciona_jedinica_funkcija': 'Функција унутар организационе јединице',
    'Organizaciona_jedinica_funkcija_obavezna': 'Функција унутар организационе јединице je обавезнa',
    'Obrisi': 'Обриши',
    'uspjesno_obrisan_tekst': 'Успјешно обрисан текст',
    'uspjesno_obrisan_dokument': 'Успјешно обрисан документ',
    'email_neispravan': 'Емаил адреса није у исправном формату',
    'potvrdi': 'Потврди',
    'pitanje_brisanje_info_teksta': 'Да ли сте сигурни да желите избрисати инфо текст',
    'potvrda_brisanja_info_teksta': 'Потврда брисања инфо текста',
    'pitanje_brisanje_info_dokumenta': 'Да ли сте сигурни да желите избрисати инфо документ',
    'potvrda_brisanja_info_dokumenta': 'Потврда брисања инфо документа',
    'Promijeni_lozinku': 'Промијени лозинку',
    'Akcija': 'Акција',
    'uspjesno_promijenjena_lozinka': 'Успјешно сте промијенили лозинку',
    'administracija': 'Администрација',
    'sifrarnici': 'Шифрарници',
    'korisnici': 'Корисници',
    'lista_korisnika': 'Листа корисника',
    'unos_novog_korisnika': 'Унос новог корисника',
    'izmjena_korisnika': 'Измјена корисника',
    'offline_javne_rasprave': 'Офлине јавне расправе',
    'lista_offline_javnih_rasprava': 'Листа офлине јавних расправа',
    'unos_nove_offline_javne_rasprave': 'Унос нове офлине јавне расправе',
    'izmjena_offline_javne_rasprave': 'Измјена офлине јавне расправе',
    'korisnici_rest_servisa': 'Корисници РЕСТ сервиса',
    'lista_korisnika_rest_servisa': 'Листа корисника РЕСТ сервиса',
    'unos_novog_korisnika_rest_servisa': 'Унос новог корисника РЕСТ сервиса',
    'izmjena_korisnika_rest_servisa': 'Измјена корисника РЕСТ сервиса',
    'organizacione_jedinice': 'Организационе јединице',
    'lista_organizacionih_jedinica': 'Листа организационих јединица',
    'unos_nove_organizacione_jedinice': 'Унос нове организационе јединице',
    'izmjena_organizacione_jedinice': 'Измјена организационе јединице',
    'funkcije_organizacione_jedinice': 'Функције организационе јединице',
    'lista_funkcija_organizacione_jedinice': 'Листа функција организационе јединице',
    'unos_nove_funkcije_org_jedinice': 'Унос нове функције организационе јединице',
    'izmjena_funkcije_org_jedinice': 'Измјена функције организационе јединице',
    'kategorije': 'Категорије',
    'lista_kategorija': 'Листа категорија',
    'unos_nove_kategorije': 'Унос нове категорије',
    'izmjena_kategorije': 'Измјена категорије',
    'tipovi_sesije_javne_rasprave': 'Типови сесије јавне расправе',
    'lista_tipova_sesije_javne_rasprave': 'Листа типова сесије јавне расправе',
    'unos_novog_tipa_sesije_javne_rasprave': 'Унос новог типа сесије јавне расправе',
    'izmjena_tipa_sesije_javne_rasprave': 'Измјена типа сесије јавне расправе',
    'osjetljive_kategorije': 'Осјетљиве категорије',
    'lista_osjetljivih_kategorija': 'Листа осјетљивих категорија',
    'unos_nove_osjetljive_kategorije': 'Унос нове осјетљиве категорије',
    'izmjena_osjetljive_kategorije': 'Измјена осјетљиве категорије',
    'tipovi_dokumenta': 'Типови документа',
    'lista_tipova_dokumenta': 'Листа типова документа',
    'unos_novog_tipa_dokumenta': 'Унос новог типа документа',
    'izmjena_tipa_dokumenta': 'Измјена типа документа',
    'info_sekcija': 'Инфо секција',
    'lista_tekstova_info_sekcije': 'Листа текстова инфо секције',
    'info_section': 'Инфо секција',
    'info_section_texts_list': 'Листа текстова инфо секције',
    'unos_novog_teksta_info_sekcije': 'Унос новог текста инфо секције',
    'izmjena_teksta_info_sekcije': 'Измјена текста инфо секције',
    'lista_dokumenata_info_sekcije': 'Листа докумената инфо секције',
    'unos_novog_dokumenta_info_sekcije': 'Унос новог документа инфо секције',
    'izmjena_dokumenta_info_sekcije': 'Измјена документа инфо секције',
    'pocetna': 'Почетна',
    'prituzbe': 'Притужбе',
    'prijava_problema': 'Пријава проблема',
    'Vrsta prijave': 'Врста пријаве',
    'Polje za registraciju': 'Поље за регистрацију',
    'Vidljivo': 'Видљиво',
    'Obavezno': 'Обавезно',
    'Osjetljiva_kategorija': 'Осјетљива категорија',
    'Osjetljiva_kategorija_obavezna': 'Осјетљива категорија је обавезна',
    'Reset_': 'Поништи',
    'Filtriraj_': 'Претражи',
    'Iskljuci_filter': 'Искључи филтер',
    'Ukljuci_filter': 'Укључи филтер',
    'konfiguracija-sistemskih-parametara': 'Конфигурација системских параметара',
    'obavezna-polja-za-registraciju': 'Обавезна поља за регистрацију',
    'odabir-vrste-prijave': 'Одабир врсте пријаве',
    'konfiguracija-prituzbi': 'Конфигурација притужби',
    'lista-podnesenih-prituzbi': 'Листа поднесених притужби',
    'Problem': 'Проблем',
    'Kategorija': 'Категорија',
    'Datum': 'Датум',
    'Status': 'Статус',
    'korisnik': 'Корисник',
    'kategorija_obavezna': 'Категорија је обавезна',
    'izaberi_dokument': 'Изабери документ',
    'dodaj_dokumente': 'Додај документе',
    'uspjesno_ucitano': 'Успјешно учитано',
    'ucitavanje_nije_uspjelo': 'Учитавање није успјело',
    'uredjivanje_prituzbe': 'Уређивање притужбе',
    'detalji_prituzbe': 'Детаљи притужбе',
    'Slike': 'Слике',
    'Lokacija': 'Локација',
    'Komentari': 'Коментари',
    'Dodijeljen': 'Додијељен',
    'Neodgovarajuca': 'Непримјерена',
    'Dodijeli': 'Додијели',
    'dodijeli_i_postavi_kao_vidljivo': 'Додијели и постави као видљиво',
    'Promijeni_status': 'Промијени статус',
    'Novi_komentar': 'Нови коментар',
    'Sacuvaj': 'Сачувај',
    'Komentar': 'Коментар',
    'Komentar_kreirao': 'Коментар креирао',
    'Fajl': 'Фајл',
    'Datum_vrijeme': 'Датум и вријеме',
    'Odabir_statusa_obavezan': 'Одабир статуса је обавезан',
    'Unos_komentara_obavezan': 'Унос коментара је обавезан',
    'Odabir_organizacije_obavezan': 'Одабир организације је обавезан',
    'dokumenti_nisu_uploadovani': 'Документи нису успјешно уплоадовани!',
    'opis_lokacije': 'Опис локације',
    'nastavi': 'Настави',
    'odaberi_sliku': 'Одабери слику',
    'zavrsi': 'Заврши',
    'uspjesna_prijava_problema': 'Успјешно сте пријавили проблем',
    'uspjesno_snimanje_slike': 'Успјешно сте снимили слику',
    'lista_konfiguracijskih_parametara': 'Листа конфигурацијских параметара',
    'uredjivanje_konfiguracijskih_parametara': 'Уређивање конфигурацијског параметра',
    'lista-mojih-prituzbi': 'Листа мојих поднесених притужби',
    'uspjesno_obrisan_fajl': 'Успјешно сте обрисали фајл',
    'Prijavi_problem': 'ПРИЈАВИ ПРОБЛЕМ',
    'moja-prituzba': 'Моја притужба',
    'Neodgovarajuci_sadrzaj': ' Ова притужба се не приказије због непримјереног садржаја',
    'odabir-vrste-verifikacije-registracije': 'Одабир врсте верификације регистрације',
    'Nacin_slanja': 'Начин слања',
    'notifikacije_poslate_od_strane_korisnika': 'Нотификације послате од стране корисника',
    'lista_notifikacija_poslatih_od_strane_korisnika': 'Листа нотификација послатих од стране корисника',
    'notifikacije': 'Нотификације',
    'unos_nove_notifikacije': 'Уноц нове нотификације',
    'izmjena_notifikacije': 'Измјена нотификације',
    'pitanje_brisanje_notifikacija': 'Да ли сте сигурни да желите избрисати нотификацију',
    'potvrda_brisanja_notifikacija': 'Потврда брисања нотификације',
    'uspjesno_obrisana_notifikacija': 'Нотификација је успјешно обрисана',
    'uspjesno_snimljen_odgovor': 'Одговор је успјешно снимљен',
    'uspjesno_snimljeno': 'Успјешно снимљено',
    'user_already_exists': 'Корисничко име већ постоји у систему',
    'incorrect_username_or_password': 'Погрешно корисничко име или шифра',
    'email_not_valid_format': 'Емаил адреса није у исправном формату',
    'unable_to_send_email_check_email': 'Активацијски код није послат на емаил. Провјерите унесену емаил адресу.',
    'unable_to_send_sms_check_telephone_number': 'Активацијски код није послат смс-ом. Провјерите унесени број телефона.',
    'telefon_neispravan': 'Телефонски број није у исправном формату.',
    'Kod_obavezan': 'Код је обавезан',
    'Slanje_not_SMS_om': 'Слање обавјештења СМС-ом',
    'Slanje_not_Email_om': 'Слање обавјештења Емаил-ом',
    'Slanje_not_Push_om': 'Слањe обавјештења Пуш нотификацијама',
    'sms': 'СМС',
    'email': 'Email',
    'push': 'Push',
    'sistemske-notifikacije': 'Системске нотификације',
    'sistemske-notifikacije-lista': 'Листа системских нотификација',
    'sistemske-notifikacije-detalji': 'Детаљи системске нотификације',
    'potvrda_registarcije_email': 'Молимо Вас потврдите регистрацију кликом на линк који се добили на емаил!',
    'Vrijednost': 'Вриједност',
    'Neodgovarajuci': 'Непримјерен',
    'Oznaci_kao_vidljivo': 'Означи као видљиво',
    'Snimi': 'Сними',
    'Odgovor': 'Одговор',
    'Unos_odgovora_obavezan': 'Унос одговора је обавезан',
    'Sacuvaj_odgovor': 'Сачувај одговор',
    'Fajl_odgovora': 'Фајл одговора',
    'Dodavanje_fajla': 'Додавање фајла',
    'Korisnik': 'Корисник',
    'godina_rodjenja_mora_biti_manja_od_trenutne': 'Година рођења мора бити мања или једнака тренутној!',
    'uspjesno_ste_potvrdili_registraciju': 'Успјешно сте потврдили регистрацију! Уколико желите да наставите користити апликацију као регистровани корисник кликните на дугме "Потврди"!',
    'varification_code_not_valid': 'Код за верификацију регистрације није исправан!',
    'Potvrdi': 'Потврди',
    'Odaberi_primaoce': 'Одабери примаоце',
    'Ponovo_posalji_email': 'Поново пошаљи емаил',
    'Ponovo_posalji_sms': 'Поново пошаљи СМС',
    'kod_ponovo_poslan_putem_sms_poruke': 'Верификацијски код поново послат путем СМС-а!',
    'verifikacijski_mail_ponovo_poslan': 'Верификацијски маил поново послат!',
    'Datum_slanja': 'Датум слања',
    'Poslato': 'Послато',
    'incorrect_old_password': 'Погрешна стара лозинка',

    'uspjesna_odjava': 'Успјешно сте се одјавили',
    'Nacin_slanja_obavezan': 'Одабир начина слања је обавезан',
    'promijeni_lozinku': 'Промјена лозинке',
    'promijeni_lozinku_korisnika_rest_servisa': 'Промијени лозинку корисника рест сервиса',
    'info_dokumenti': 'Инфо документи',
    'Vrijeme_odgovora': 'Вријеме одговора',
    'Starost': 'Старост',
    'Broj_prituzbe': 'Број притужбе',
    'Datum_prituzbe': 'Датум притужбе',
    'Ime_Prezime': 'Име и презиме',
    'Autor': 'Аутор',
    'izvjestaji': 'Извјештаји',
    'prituzbe_zadati_vremenski_okvir': 'Листа пријављених притужби у задатом временском оквиру',
    'prituzbe_vrijeme_odgovora': 'Вријеме одговора (Просјечно, Максимално, Минимално)',
    'prituzbe_kategorija_status': 'Листа пријављених притужби по категорији и статусу',
    'prituzbe_profilni_podaci': 'Листа пријављених притужби по профилним подацима',
    'prituzbe_datum_rjesavanja': 'Листа пријављених притужби по датуму рјешавања притужбе',
    'Datum_kreiranja_od': 'Датум креирања од',
    'Datum_kreiranja_do': 'Датум креирања до',
    'Tip': 'Тип',
    'Pretraga': 'Претрага',
    'Nazad': 'Назад',
    'Datum_rjesavanja': 'Датум рјешавања',
    'Datum_rjesavanja_od': 'Датум рјешавања од',
    'Datum_rjesavanja_do': 'Датум рјешавања до',
    'Datum_izmjene': 'Датум измјене',
    'Datum_kreiranja': 'Датум креирања',

    'sve_prituzbe': "Све притужбе",
    'statistika': 'Статистика',
    'javne_rasprave': 'Јавне расправе',
    'online_јavne_rasprave': 'Онлине јавне расправе',
    'Datum_pocetka': 'Датум почетка',
    'Datum_kraja': 'Датум краја',
    'Status_javne_rasprave_obavezan': 'Статус јавне расправе је обавезан',
    'Privilegije_obavezno': 'Привилегије су обавезне',
    'Datum_pocetka_obavezan': 'Датум почетка је обавезан',
    'Datum_kraja_obavezan': 'Датум краја је обавезан',
    'Aktivan_obavezno': 'Активана је обавезно',
    'Pretrage_obavezna': 'Претрага је обавезна',
    'Status_podataka_obavezan': 'Статус података је обавезан',
    'Kategorije_javne_rasprave_obavezana': 'Категорије јавне расправе је обавезна',
    'Privilegije': 'Привилегије',
    'Odabir_privilegije_obavezan': 'Одабир привилегије је обавезан',
    'tip_dokumenta': 'Тип документа',
    'Generisi_izvjestaj': 'Генериши извјештај',
    'kategorije_javnih_rasprava': 'Категорије јавних расправа',
    'lista_kategorija_javnih_rasprava': 'Листа категорија јавних расправа',
    'unos_nove_kategorije_javne_rasprave': 'Унос нове категорије јавне расправе',
    'izmjena_kategorije_javne_rasprave': 'Измјена категорије јавне расправе',
    'Pocetak': 'Почетак',
    'Kraj': 'Крај',
    'Broj_ucesnika': 'Број учесника',
    'Broj_ucesnika_filter': 'Број учесника према одабраном филтеру',
    'lista_sesija_offline_javne_rasprave': 'Листа сесија офлине јавне расправе',
    'izmjena_sesije_offline_javne_rasprave': 'Измјена сесије офлине јавне расправе',
    'unos_nove_sesije_offline_javne_rasprave': 'Унос нове сесије офлине јавне расправе',
    'Vrsta': 'Врста',
    'Odabir_vrste_javne_rasprave_obavezan': 'Одабир врсте јавне расправе',
    'Datum_zadnje_izmjene': 'Датум задње измјене',
    'sjednice': 'Сједнице',
    'lista_sjednica': 'Листа сједница',
    'unos_nove_sjednice': 'Унос нове сједнице',
    'izmjena_sjednice': 'Измјена сједнице',
    'datum_pocetka_sjednice': 'Датум почетка',
    'tacke_dnevnog_reda': 'Тачке дневног реда',
    'izmjena_tacke_dnevnog_reda': 'Измјена тачке дневног реда',
    'unos_nove_tacke_dnevnog_reda': 'Унос нове тачке дневног реда',
    'Pravo_pristupa': 'Право приступа',
    'Glasova_za': 'Гласова грађана за',
    'Glasova_protiv': 'Гласова грађана против',
    'Omoguceno_glasanje': 'Омогућено гласање',
    'Omoguceno_komentarisanje': 'Омогућено коментарисање',
    'podaci_nisu_snimljeni_nepoznat_entityStatus': 'Подаци нису снимљњни! Непознат entityStatus.',
    'Kontakt_osobe': 'Контакт особе',
    'kontakt_osoba': 'Контакт особа',
    'Funkcija': 'Функција',
    'Odgovorne_osobe': 'Одговорне особе',
    'Offline_javna_rasprava': 'Офлине јавна расправа',
    'Minimalno_vrijeme_odgovora': 'Минимално вријеме одговора',
    'Maksimalno_vrijeme_odgovora': 'Максимално вријеме одговора',
    'Prosjecno_vrijeme_odgovora': 'Просјечно вријеме одговора',
    'Ukupan_broj_prituzbi': 'Укупан број притужби',

    'Javna_rasprava_obavezno': 'Јавна расправа је обавезна',
    'Tip_sesije_obavezan': 'Врста сесије је обавезна',
    'Datum_sesije_obavezan': 'Датум је обавезан',
    'Vrijeme_pocetka_sesije_obavezno': 'Вријеме почетка је обавезно',
    'Broj_muskih_ucesnika_obavezan': 'Број мушких учесника је обавезан',
    'Broj_zenskih_ucesnika_obavezan': 'Број женских учесника је обавезан',
    'Status_sesije_obavezan': 'Статус сесије је обавезан',
    'Lokacija_sesije_obavezna': 'Локација је обавезна',
    'Lokacija_sesije': 'Локација сесије',
    'Vrijeme_pocetka': 'Вријеме почетка',
    'Vrijeme_zavrsetka': 'Вријеме завршетка',
    'Broj_muskih_ucesnika': 'Број мушких учесника',
    'Broj_zenskih_ucesnika': 'Број женских учесника',
    'Tip_sesije': 'Врста',
    'Vrijeme_pocetka_sesije_nije_validno': 'Вријеме почетка није валидно',
    'Vrijeme_zavrsetka_sesije_nije_validno': 'Вријеме завршетка није валидно',
    'Stara_lozinka': 'Стара лозинка',
    'Nova_lozinka': 'Нова лозинка',
    'Promijeni_podatke': 'Промијени податке',
    'Odjavi_se': 'Одјави се',
    'Aktivna': 'Активна',
    'Potvrda_brisanja': 'Потврда брисања',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_kontakt_osobu': 'Да ли сте сигурни да желите да обришете контакт особу',
    'Kontakt_osoba_je_uspjesno_obrisana': 'Контакт особа је успјешно обрисана',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_odgovornu_osobu': 'Да ли сте сигурни да желите да обришете одговорну особу',
    'Odgovorna_osoba_je_uspjesno_obrisana': 'Одговорна особа је успјешно обрисана',
    'Stara_lozinka_obavezna': 'Стара лозинка је обавезна',
    'Offline_javna_rasprava_ne_postoji': 'Офлине јавна расправа не постоји',
    'File_ne_postoji': 'Документ није пронађен',
    'Osobe': 'Особе',
    'Lista_osoba': 'Листа особа',
    'Unos_nove_osobe': 'Унос нове особе',
    'Izmjena_osobe': 'Измјена особе',
    'Dodaj_odgovornu_osobu': 'Додај одговорну особу',
    'Dodaj_kontakt_osobu': 'Додај контакт особу',
    'Zatvori': 'Затвори',
    'Dokumenti': 'Документи',
    'Preuzmi': 'Преузми',
    'Dodaj_dokument': 'Додај документ',
    'Uredi_dokument': 'Уреди документ',
    'Dokument_obavezan': 'Документ је обавезан',
    'Korisnicko_ime_min_duzina': 'Минимална дужина корисничког имена је 4 карактера',
    'Korisnicko_ime_max_duzina': 'Максимална дужина корисничког имена је 15 карактера',
    'email_already_exists': 'Унесена емаил адреса већ постоји у систему',
    'telephone_number_already_exists': 'Унесени телефонски број већ постоји у систему',
    'broj_telefona_obavezan': 'Број телефона је обавезан',
    'Kreirao': 'Креирао',
    'Uploadovani_dokument_nije_pronadjen': 'Уплоадовани документ није пронађен',
    'Uploadovani_dokument_nije_validan': 'Уплоадовани документ није валидан. Документ мора бити у једном од наведених формата: .pdf,.doc,.docx,.jpeg,.jpg,.mov,.png,.bmp,.xlsx,.xls',
    'Uploadovani_fajl_komentara_nije_validan': 'Коментар је сачуван без фајла. Подржани формати фајлова су: .pdf,.doc,.docx,.jpeg,.jpg,.mov,.png,.bmp,.xlsx,.xls',
    'Deaktivacija_profila': 'Деактивација профила',
    'Deaktivacija_profila_poruka': 'Деактивацијом профила више нећете бити у могућности да приступите Вашем налогу и његовом садржају. Сав Ваш унесени садржај ће и даље остати у систему. Да ли сте сигурни да желите да деактивирате профил?',
    'Zaboravili_ste_korisnicko_ime_ili_lozinku': 'Заборавили сте корисничко име или лозинку?',
    'poslat_mejl_sa_novom_lozinkom': 'Корисничко име и нова лозинка су послати на Вашу е-маил адресу.',
    'unable_to_find_user_with_entered_email': 'Корисник са унесеном емаил адресом није пронађен у систему.',
    'slanje_nije_uspjelo': 'Слање није успјело.',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_dokument': 'Да ли сте сигурни да желите да обришете документ',
    'Dokument_je_uspjesno_obrisan': 'Документ је успјешно обрисан',
    'izmjena_dokumenta': 'Измјена документа',
    'unos_novog_dokumenta': 'Унос новог документа',
    'unos_novog_dodatnog_materijala': 'Унос новог додатног материјала/обавијести',
    'izmjena_dodatnog_materijala': 'Измјена додатног материјала/обавијести',
    'datum_zavrsetka_sjednice': 'Датум завршетка',
    'status_sjednice_obavezan': 'Статус сједнице је обавезан',
    'pravo_pristupa_obavezno': 'Право приступа је обавезно',
    'datum_pocetka_sjednice_obavezan': 'Датум почетка је обавезан',
    'status_tacke_dnevnog_reda_obavezan': 'Статус тачке дневног реда је обавезан',
    'Dodaj_sesiju': 'Додај сесију',
    'Token_uredjaja': 'Токен уређаја',
    'vrijeme_pocetka_sjednice_obavezno': 'Вријеме почетка је обавезно',
    'vrijeme_pocetka_sjednice_nije_validno': 'Вријеме почетка није валидно',
    'vrijeme_zavrsetka_sjednice_nije_validno': 'Вријеме завршетка није валидно',
    'dokument_uspjesno_obrisan': 'Документ успјешно обрисан',
    'Dodaj_pitanje': 'Додај питање',
    'Uredi_pitanje': 'Уреди питање',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_pitenje': 'Да ли сте сигурни да желите обрисати питање',
    'Pitanje_je_uspjesno_obrisano': 'Питање је успјешно обрисано',
    'Pitanja_i_odgovori': 'Питања и одговори',
    'Pitanje': 'Питање',
    'Jls_Kontakt': 'ЈЛС контакт',
    'Gradjanin': 'Грађанин',
    'Aktivno': 'Активно',
    'Pitanje_je_obavezno': 'Питање је обавезно',
    'Odgovor_je_preveliki': 'Одговор је превелики',
    'Jls_Kontakt_nije_validan': 'ЈЛС контакт није исправан',
    'Gradjanin_je_obavezan': 'Грађанин је обавезан',
    'Email_nije_validan': 'Емаил није исправан',
    'Pitanje_ne_postoji': 'Питање не постоји',
    'detalji_sjednice': 'Детаљи сједнице',
    'detalji_tacke_dnevnog_reda': 'Детаљи тачке дневног реда',
    'online_javne_rasprave': 'Онлине јавне расправе',
    'lista_online_javnih_rasprava': 'Листа онлине јавних расправа',
    'Prijavite se na nas newsletter': 'Пријавите се на наш newsletter',
    'uspjesna_prijava_na_newsletter': 'Успјешно сте се пријавили на newsletter',
    'Posalji': 'Пошаљи',
    'pitanje_newsletter_slanje': 'Да ли сте сигурни да желите послати нотификацију корисницима пријављеним на newsletter',
    'potvrda_newsletter_slanje': 'Потврда слања newsletter-a',
    'uspjesno_poslata_notifikacija_na_newsletter': 'Нотификација је успјешно послата',
    'glasaj_za': 'Гласај за',
    'glasaj_protiv': 'Гласај против',
    'vote_already_added': 'Већ сте гласали за ову тачку дневног реда',
    'glasanje_uspjesno': 'Ваш глас је запримљен. Хвала што сте гласали!',
    'Godina_rodjenja_obavezna_duzina': 'Година рођења мора садржати 4 карактера',
    'unos_nove_online_javne_rasprave': 'Унос нове онлине јавне расправе',
    'izmjena_online_javne_rasprave': 'Измјена онлине јавне расправе',
    'godina_rodjenja_se_sastoji_od_cetiri_cifre': 'Година рођења се мора састојати од четири цифре',
    'Uslovi_zahtjevi': 'Услови и захтјеви',
    'Politika_privatnosti': 'Политика приватности',
    'Kontakti_za_pomoc': 'Контакти за помоћ',
    'Korisnicko_uputstvo': 'Корисничко упутство',
    'naziv_tacke_dnevnog_reda': 'Назив тачке дневног реда',
    'naziv_podtacke_dnevnog_reda': 'Назив подтачке дневног реда',
    'Online_javna_rasprava': 'Онлине јавна расправа',
    'Dodaj_diskusiju': 'Додај дискусију',
    'Diskusije': 'Дискусије',
    'lista_diskusija_online_javne_rasprave': 'Листа дискусија онлине јавне расправе',
    'izmjena_diskusije_online_javne_rasprave': 'Измјена дискусије онлине јавне расправе',
    'unos_nove_diskusije_online_javne_rasprave': 'Унос нове дискусије онлине јавне расправе',
    'Posalji_izvjestaj': 'Пошаљи извјештај',
    'Finalni_izvjestaj': 'Финални извјештај',
    'nedostaje_dokument': 'Недостаје документ',
    'sazivi': 'Сазиви',
    'lista_saziva': 'Листа сазива',
    'trenutni_saziv': 'Тренутни сазив',
    'unos_novog_saziva': 'Унос новог сазива',
    'datum_pocetka_saziva': 'Датум почетка сазива',
    'datum_zavrsetka_saziva': 'Датум завршетка сазива',
    'datum_pocetka_saziva_obavezan': 'Датум почетка сазива је обавезан',
    'datum_zavrsetka_saziva_obavezan': 'Датум завршетка сазива је обавезан',
    'izmjena_saziva': 'Измјена сазива',
    'politicke_partije': 'Политичке партије',
    'lista_politickih_partija': 'Листа политичких партија',
    'unos_nove_politicke_partije': 'Унос нове политичке партије',
    'izmjena_politicke_partije': 'Измјена политичке партије',
    'skraceni_naziv': 'Скраћени назив',
    'politicka_partija': 'Политичка партија',
    'skraceni_naziv_obavezan': 'Скраћени назив је обавезан',
    'saziv': 'Сазив',
    'Sesija_offline_javne_rasprave_ne_postoji': 'Сесија офлине јавне расправе не постоји',
    'Diskusija_online_javne_rasprave_ne_postoji': 'Дискусија онлине јавне расправе не постоји',
    'Komentar_ne_postoji': 'Коментар не постоји',
    'Naziv_diskusije_je_obavezan': 'Назив дискусије је обавезан',
    'To_obavezno': 'То је обавезно',
    'Slanje_finalnog_izvjestaja_za_sesiju_ofline_javne_rasprave': 'Слање финалног извјештаја за сесију офлине јавне расправе',
    'To': 'То',
    'Cc': 'Цц',
    'Subject': 'Наслов поруке',
    'Subject_obavezno': 'Наслов поруке је обавезан',
    'Message': 'Текст поруке',
    'Message_obavezan': 'Текст поруке је обавезан',
    'finalni_izvjestaj_je_uspjesno_poslat': 'Финални извјештај је успјешно послат!',
    'finalni_izvjestaj_nije_uspjesno_poslat': 'Финални извјештај није успјешно послат. Покушајте поново!',
    'Datum_diskusije_obavezan': 'Датум дискусије је обавезан',
    'tip_clana': 'Тип члана',
    'kratka_biografija': 'Кратка биографија',
    'tip_clana_obavezan': 'Тип члана је обавезан',
    'politicka_partija_obavezna': 'Политичка партија је обавезна',
    'saziv_obavezan': 'Сазив је обавезан',
    'korisnik_obavezan': 'Корисник је обавезан',
    'slika_obavezna': 'Слика је обавезна',
    'kratka_biografija_obavezna': 'Кратка биографија је обавезна',
    'sve_sjednice': 'Све сједнице',
    'Odaberi': 'Одабери',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_poveznicu': 'Да ли сте сигурни да желите да обришете повезницу',
    'Poveznica_je_uspjesno_obrisana': 'Повезница је успјешно обрисана',
    'Poveznice': 'Повезнице',
    'Poveznica': 'Повезница',
    'Dodaj_poveznicu_na_sjednicu': 'Додај повезницу на сједницу',
    'Dodaj_poveznicu_na_prituzbu': 'Додај повезницу на притужбу',
    'Dodavanje_poveznice_na_sjednicu': 'Додавање повезнице на сједницу',
    'Dodavanje_poveznice_na_prituzbu': 'Додавање повезнице на притужбу',
    'Sjednica': 'Сједница',
    'detalji_pitanja': 'Детаљи питања',
    'ime_prezime': 'Име и презиме',
    'broj_pitanja': 'Број питања',
    'broj_odgovora': 'Број одговора',
    'detalji_offline_javne_rasprave': 'Детаљи офлине јавне расправе',
    'pitanje_postavio': 'Питање поставио',
    'datum_pitanja': 'Датум питања',
    'pitanje': 'Питање',
    'odgovor': 'Одговор',
    'pitanja': 'Питања',
    'pitanje_aktivno': 'Питање активно',
    'odgovor_aktivan': 'Одговор активан',
    'Tacka_dnevnog_reda': 'Тачка дневног реда',
    'Broj_glasanja': 'Број гласања',
    'Broj_komentara': 'Број коментара',
    'komentari_glasovi_tacaka_dnevnog_reda': 'Број коментара и гласања по тачкама дневног реда',
    'komentari_glasovi_sjednica': 'Број коментара и гласања по сједницама',
    'tekst_pitanja': 'Текст питања',
    'odgovorio': 'Одговорио',
    'datum_odgovora': 'Датум одговора',
    'tekst_odgovora': 'Текст одговора',
    'neprimjereno': 'Непримјерено',
    'nacin_unosa_odgovora': 'Начин уноса одговора',
    'postavi_pitanje': 'ПОСТАВИ ПИТАЊЕ',
    'unesite_tekst_pitanja': 'Унесите текст питања',
    'tekst_pitanja_obavezan': 'Текст питања је обавезан',
    'tekst_odgovora_obavezan': 'Текст одговора је обавезан',
    'nema_odgovora': 'Нема одговора',
    'Datum_pocetka_od': 'Датум почетка од',
    'Datum_pocetka_do': 'Датум почетка до',
    'Prituzbe': 'Притужбe',
    'Sjednice_opstinskih_vijeca': 'Сједнице',
    'Vijecnici_nacelnici_gradonacelnici': 'Питања',
    'Javne_rasprave': 'Јавне расправе',
    'pitanja_vijecnika_po_statusu': 'Број питања по статусима (Одговорени, Неодговорени)',
    'broj_odgovorenih_pitanja': 'Број одговорених питања',
    'broj_neodgovorenih_pitanja': 'Број неодговорених питања',
    'ukupno_pitanja': 'Укупно питања',
    'moja_pitanja': 'Моја питања',
    'pitanja_za_nacelnika': 'Питања за начелника',
    'pitanja_za_odbornika': 'Питања за одборникe',
    'pitanja_za_moju_administrativnu_jedinicu': 'Питања постављена мојој организационој јединици',
    'pitanja_za_organizacione_jedinice': 'Питања за организационе јединице',
    'datum_pitanja_od': 'Датум питања од',
    'datum_pitanja_do': 'Датум питања до',
    'izmijeni_profil': 'Измијени профилне податке',
    'detalji_profila': 'Детаљи профила',
    'Detalji': 'Детаљи',
    'Detalji_sesije': 'Детаљи сесије',
    'detalji_online_javne_rasprave': 'Детаљи онлине јавне расправе',
    'pitanje_zaprimljeno': 'Питање је успјешно запримљено',
    'uspjesno_odgovoreno': 'Одговор је успјешно додат',
    'morate_se_prijaviti_postavljanje_pitanja': 'Морате се пријавити на систем да бисте поставили питање!',
    'Kreirano': 'Креирано',
    'Izmijenjeno': 'Измијењено',
    'detalji_diskusije_online_javne_rasprave': 'Детаљи дискусије онлине јавне расправе',
    'Opis_diskusije': 'Опис дискусије',
    'Datum_diskusije': 'Датум дискусије',
    'Naziv_diskusije': 'Назив дискусије',
    'Datum_kraja_online_javne_rasprave': 'Датум краја онлине јавне расправе',
    'Datum_pocetka_online_javne_rasprave': 'Датум почетка онлине јавне расправе',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_offline_debatu': 'Да ли сте сигурни да желите да обришете офлине јавну расправу',
    'Offline_debata_je_uspjesno_obrisana': 'Офлине јавна расправа је успјешно обрисана',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_online_debatu': 'Да ли сте сигурни да желите да обришете онлине јавну расправу',
    'Online_debata_je_uspjesno_obrisana': 'Онлине јавна расправа је успјешно обрисана',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_sesiju_offline_debatu': 'Да ли сте сигурни да желите да обришете сесију',
    'Sesija_offline_debate_je_uspjesno_obrisana': 'Сесија је успјешно обрисана',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_diskusiju_online_debatu': 'Да ли сте сигурни да желите да обришете дискусију',
    'Diskusija_online_debate_je_uspjesno_obrisana': 'Дискусија је успјешно обрисана',
    'detalji_sesije_offline_javne_rasprave': 'Детаљи сесије офлине јавне расправе',
    'broj_pitanja_po_polu': 'Број питања по профилним подацима (родна припадност)',
    'muski_pol': 'Мушки пол',
    'zenski_pol': 'Женски пол',
    'nepoznato': 'Непознато',
    'pitanja_clanu_saziva':'Питања члану сазива',
    'Datum_pitanja_od': 'Датум питања од',
    'Datum_pitanja_do': 'Датум питања до',
    'broj_pitanja_po_kategoriji': 'Број питања по профилним подацима (осјетљива категорија)',
    'broj_pitanja_po_starosnim_grupama': 'Број питања по профилним подацима (старосна група)',
    'Jls_kontakt_email': 'ЈЛС контакт емаил',
    'Gradjanin_email': 'Грађанин емаил',
    'pitanje_brisanje_korisnika': 'Да ли сте сигурни да желите избрисати корисника',
    'potvrda_brisanja_korisnika': 'Потврда брисања корисника',
    'uspjesno_obrisan_korisnik': 'Корисник је успјешно обрисан',
    'brisanje_nije_moguce': 'Брисање није могуће',
    'pitanje_brisanje_osjetljive_kategorije': 'Да ли сте сигурни да желите избрисати осјетљиву категорију',
    'potvrda_brisanja_osjetljive_kategorije': 'Потврда брисања осјетљиве категорије',
    'uspjesno_obrisana_osjetljiva_kategorija': 'Осјетљива категорија је успјешно обрисана',
    'pitanje_brisanje_kategorije': 'Да ли сте сигурни да желите избрисати категорију',
    'potvrda_brisanja_kategorije': 'Потврда брисања категорије',
    'uspjesno_obrisana_kategorija': 'Категорија је успјешно обрисана',
    'pitanje_brisanje_saziva': 'Да ли сте сигурни да желите избрисати сазив',
    'potvrda_brisanja_saziva': 'Потврда брисања сазива',
    'uspjesno_obrisan_saziv': 'Сазив је успјешно обрисан',
    'pitanje_brisanje_politicke_partije': 'Да ли сте сигурни да желите избрисати политичку партију',
    'potvrda_brisanja_politicke_partije': 'Потврда брисања политичке партије',
    'uspjesno_obrisana_politicka_partija': 'Политичка партија је успјешно обрисана',
    'pitanje_brisanje_funkcije_organizacione_jedinice': 'Да ли сте сигурни да желите избрисати функцију организационе јединице',
    'potvrda_brisanja_funkcije_organizacione_jedinice': 'Потврда брисања функције организационе јединице',
    'uspjesno_obrisana_funkcija_organizacione_jedinice': 'Функција организационе јединице је успјешно обрисана',
    'pitanje_brisanje_tipa_dokumenta': 'Да ли сте сигурни да желите избрисати тип документа',
    'potvrda_brisanja_tipa_dokumenta': 'Потврда брисања типа документа',
    'uspjesno_obrisan_tip_dokumenta': 'Тип документа је успјешно обрисан',
    'pitanje_brisanje_tipa_sesije_javne_rasprave': 'Да ли сте сигурни да желите избрисати тип сесије јавне расправе',
    'potvrda_brisanja_tipa_sesije_javne_rasprave': 'Потврда брисања типа сесије јавне расправе',
    'uspjesno_obrisan_tip_sesije_javne_rasprave': 'Тип сесије јавне расправе је успјешно обрисан',
    'pitanje_brisanje_kategorije_javnih_rasprava': 'Да ли сте сигурни да желите избрисати категорију јавне расправе',
    'potvrda_brisanja_kategorije_javnih_rasprava': 'Потврда брисања категорије јавне расправе',
    'uspjesno_obrisana_kategorija_javnih_rasprava': 'Категорија јавне расправе је успјешно обрисана',
    'pitanje_brisanje_zalbe': 'Да ли сте сигурни да желите избрисати притужбу',
    'potvrda_brisanja_zalbe': 'Потврда брисања притужбе',
    'uspjesno_obrisana_zalba': 'Притужба је успјешно обрисана',
    'Datum_kraja_ne_moze_biti_manji_od_datum_pocetka': 'Датум краја не може бити мањи од датум почетка',
    'Odabrana_osoba_je_vec_dodata_kao_odgovorna_osoba': 'Одабрана особа је већ додата као одговорна особа',
    'Odabrana_osoba_je_vec_dodata_kao_kontakt_osoba': 'Одабрана особа је већ додата као контакт особа',
    'Odabrana_poveznica_na_sjednicu_je_vec_dodata': 'Одабрана повезница на сједницу је већ додата',
    'Odabrana_poveznica_na_prituzbu_je_vec_dodata': 'Одабрана повезница на притужбу је већ додата',
    'pitanje_brisanje_osobe': 'Да ли сте сигурни да желите избрисати особу',
    'potvrda_brisanja_osobe': 'Потврда брисања особе',
    'uspjesno_obrisana_osoba': 'Особа је успјешно обрисана',
    'pitanje_brisanje_sjednice': 'Да ли сте сигурни да желите избрисати сједницу',
    'potvrda_brisanja_sjednice': 'Потврда брисања сједнице',
    'uspjesno_obrisana_sjednica': 'Сједница је успјешно обрисана',
    'pitanje_brisanje_organizacije': 'Да ли сте сигурни да желите избрисати организациону јединицу',
    'potvrda_brisanja_organizacije': 'Потврда брисања организационе јединице',
    'uspjesno_obrisana_organizacija': 'Организациона јединица је успјешно обрисана',
    'komentarisi_raspravu': 'КОМЕНТАРИШИ РАСПРАВУ',
    'komentarisi_sjednicu': 'КОМЕНТАРИШИ СЈЕДНИЦУ',
    'Datum_diskusije_mora_biti_izmedju_datuma_pocetka_i_datuma_kraja_javne_rasprave': 'Датум дискусије мора бити између датума почетка и датума краја јавне расправе',
    'Datum_sesije_mora_biti_izmedju_datuma_pocetka_i_datuma_kraja_javne_rasprave': 'Датум сесије мора бити између датума почетка и датума краја јавне расправе',
    'Tip_debate': 'Тип јавне расправе',
    'Datum_od': 'Датум од',
    'Datum_do': 'Датум до',
    'Online': 'Онлине',
    'Offline': 'Офлине',
    'Ispod_18': 'Испод 18',
    'Preko_55': 'Преко 55',
    'Starosna_grupa': 'Старосна група',
    'Datum_prituzbe_od': 'Датум притужбе од',
    'Datum_prituzbe_do': 'Датум притужбе до',
    'preko_72h': 'Преко 72h',
    'kontakti_za_pomoc': 'Контакти за помоћ',
    'politika_privatnosti': 'Политика приватности',
    'uslovi_zahtjevi': 'Услови и захтјеви',
    'redni_broj': 'Редни број',
    'redni_podbroj': 'Редни подброј',
    'unesite_redni_broj': 'Унесите редни број',
    'item_number_already_exists': 'Унесени редни број већ постоји',
    'item_subnumber_already_exists': 'Унесени редни поброј већ постоји',
    'naziv_tacke_dnevnog_reda_max_duzina': 'Назив не може бити дужи од 2000 карактера',
    'opis_tacke_dnevnog_reda_max_duzina': 'Опис не може бити дужи од 2000 карактера',
    'DodajPodtocku': 'Додај подточку',
    'status_obavezan': 'Одаберите статус',
    'objavljen': 'Објављен',
    'Za': 'За',
    'Protiv': 'Против',
    'Suzdrzani': 'Суздржани',
    'Odsutni': 'Одсутни',
    'saziv_je_obavezan': 'Сазив је обавезан',
    'pojedinacna_sjednica': 'Појединачна сједница',
    'Tip_statistike': 'Тип статистике',
    'Datum_sjednice_od': 'Датум сједнице од',
    'Datum_sjednice_do': 'Датум сједнице дo',
    'broj_tacaka_dnevnog_reda': 'Број тачака дневног реда',
    'broj_dokumenata': 'Број докумената',
    'Svi': 'Сви',
    'tacke_dnevnog_reda_dokumenti_sjednica': 'Број тачака дневног реда и докумената по сједницама',
    'datum_trajanje_sjednica': 'Одржане сједнице у датумском интервалу са дужином трајања сједница',
    'trajanje_sjednice': 'Трајање сједнице',
    'Datum_zavrsetka_od': 'Датум завршетка од',
    'Datum_zavrsetka_do': 'Датум завршетка дo',
    'Datum_vrijeme_zavrsetka': 'Datum i vrijeme završetka',
    'Datum_vrijeme_pocetka': 'Datum i vrijeme početka',
    'sjednice_podaci': 'Подаци о сједницама',
    'Ucestvujte_u_diskusiji': 'Учествујте у дискусији',
    'Dodaj_komentar': 'Додај коментар',
    'sesije_sa_brojem_ucesnika': 'Сесије по јавним расправама са бројем учесника',
    'javna_rasprava': 'Јавна расправа',
    'Datum_zavrsetka': 'Датум завршетка',
    'Datum_sesije': 'Датум сесије',
    'broj_ucesnika_po_tipu_sesije': 'Broj učesnika po tipu sesije',
    'javne_rasprave_po_kategorijama': 'Javne rasprave po kategorijama',
    'broj_ucesnika_sesija_po_lokaciji': 'Broj učesnika i sesija po lokaciji',
    'tip_sesije': 'Тип сесије',
    'tip_javne_rasprave': 'Тип јавне расправе',
    'kategorija_javne_rasprave': 'Категорија јавне расправе',
    'broj_sesija': 'Број сесија',
    'br': 'Бр.',
    'GradjanaZa': 'Грађана за',
    'GradjanaProtiv': 'Грађана против',
    'neprimjeren': 'Непримјерен',
    'broj_odgovorenih': 'Број одговорених',
    'broj_neodgovorenih': 'Број неодговорених',
    'broj_odgovorenih_neodgovorenih_pitanja': 'Број одговорених и неодговорених питања',
    'sva_pitanja': 'Сва питања',
    'offline_javne_rasprave_sa_ukupnim_brojem_ucesnika': 'Офлине јавне расправе са укупним бројем учесника',
    'slanje_notifikacije_sms': 'Слање нотификације - СМС',
    'slanje_notifikacije_email': 'Слање нотификације - Емаил',
    'slanje_notifikacije_push': 'Слање нотификације - Пуш',
    'Broj_javnih_rasprava': 'Број јавних расправа',
    'politika_privatnosti_tekst': 'Приликом регистрације у сврху кориштења онлине сервиса прикупљају се подаци о корисницима. Подаци прикупљени овим путем (е-маил адресе, бројеви телефона) искључиво ће бити кориштени за контактирање с корисницима и ни под којим условима неће бити дати на кориштење трећој страни. Одговорност за тачност информација о личним подацима сносе корисници странице. \n\n Демографски подаци о корисницима бити ће кориштени за потребе извјештавања и анализа активности корисника. Сви подаци ће бити кориштени анонимно и неће их бити могуће повезати са емаил адресама или бројевима телефона.',
    'uslovi_zahtjevi_podnaslov1': 'Прихватање услова кориштења',
    'uslovi_zahtjevi_tekst1': 'Молимо Вас да пажљиво прочитате услове кориштења прије самог кориштења ове wеб - странице. Приступањем wеб-страници и осталим онлине сервисима и кориштењем материјала с wеб-странице и осталих онлине сервиса, обавезујете се прихватити наведена правила кориштења. Уколико се не слажете с овим правилима кориштења, молимо Вас да не користите информације са ове wеб-странице.',
    'uslovi_zahtjevi_podnaslov2': 'Одрицање од одговорности',
    'uslovi_zahtjevi_tekst2': 'Власник Wеб странице са онлине сервисима за Грађане не сноси одговорност за изравну или неизравну штету која може наступити као посљедица кориштења или немогућности кориштења докумената, информација, материјала или садржаја с wеб-странице, или за посљедице одлука донесених на темељу њих. Дозвољено је навођење повезнице на ову wеб - страницу, под условом да садржаји с wеб - странице нису измијењени и/или искривљени.',
    'uslovi_zahtjevi_podnaslov3': 'Измјена и допуна садржаја',
    'uslovi_zahtjevi_tekst3': 'Власник задржава право измјена и допуна садржаја на wеб-страници без претходне најаве. Wеб - страница се редовно ажурира.',
    'uslovi_zahtjevi_podnaslov4': 'Ауторска права',
    'uslovi_zahtjevi_tekst4': 'Власник задржава ауторско право на ову wеб-страницу и на комплетан садржај, осим ако није изричито назначено другачије. Допуштено је кориштење и цитирање материјала са странице, уз услов обвезног навођења извора информација и навођења повезнице на ову страницу. Садржај информација преузетих с wеб - странице не смије бити мијењан или брисан. Материјал с ове wеб-странице забрањено је користити у комерцијалне сврхе.',
    'kontakti_za_pomoc_tekst': 'Контактирајте нас уколико Вам је потребна помоћ приликом кориштења eCitizen система\n\nЕмаил адреса:  ',
    'kontakti_za_pomoc_email': 'ecitizen_support@king-ict.ba',
    'Izvjestaj': 'Извјештај',
    'Generisi_dokument': 'Генериши документ',
    'Grupisanje_po': 'Груписање по',
    'Godina/Mjesec (Datum pritužbe)': 'Година/Мјесец (Датум притужбе)',
    'broj_javnih_rasprava_po_vrsti': 'Број јавних расправа по врсти',
    'vrsta_javne_rasprave': 'Врста јавне расправе',
    'status_javne_rasprave': 'Статус јавне расправе',
    'broj_javnih_rasprava_po_mjesecima_tipu': 'Број јавних расправа по мјесецима и типу',
    'komentari_po_profilnim_podacima': 'Коментари по профилним подацима',
    'Godina': 'Година',
    'Mjesec': 'Мјесец',
    'Datum_pocetka_javne_rasprave': 'Датум почетка јавне расправе',
    'disclaimer': 'Веб портал eCitizen развијен је у оквиру Пројекта општинског околишног управљања (МЕГ2) којег заједнички  финансирају Влада Швицарске, Шведска и Влада Чешке Републике, као и Европска унија, а проводи га Развојни програм Уједињених нација (УНДП) у БиХ. Садржај ове странице, као и ставови приказани на страници, не одражавају нужно ставове Владе Швицарске, Шведске, Владе Чешке Републике, Европске уније, нити УНДП-а.',
    'Clan_kolegijuma': 'Члан колегијума',
    'Clan_radnog_tijela': 'Члан радног тијела',
    'Pravo_odgovora':'Право одговора',
    'Pravo_odgovora_detalji': 'Корисник који има "право одговора" може да одговара на питања која су постављена од стране грађана. Ако орг. јед. нема нити једнога корисника са правом одговора, на ту орг. јед. није могуће поставити питање.',
    'Kolegijum': 'Kолегијум',
    'Radna_tijela': 'Раднa тијелa',
    'Saziv_Partija': 'Сазив + Партија',
    'Kategorija_Status': 'Категорија + Статус',
    'Kategorija_Profil': 'Категорија + Профил',
    'Kategorija_Pol': 'Категорија + Пол',
    'Godina/Mjesec rasprave': 'Година/Мјесец расправе',
    'Komentar_nije_unesen': 'Коментар није унесен',
    'pitanje_brisanje_tacke_dnevnog_reda': 'Да ли сте сигурни да желите избрисати тачку дневног реда',
    'potvrda_brisanja_tacke_dnevnog_reda': 'Потврда брисања тачке дневног реда',
    'uspjesno_obrisana_tacka_dnevnog_reda': 'Тачка дневног реда је успјешно обрисана',
    'Kljucna_rijec_obavezna': 'Унесите кључну ријеч за претрагу јавне расправе',
    'Pristup_svim_sadrzajima': 'Приступ свим садржајима',
    'Kreiranje_sadrzaja': 'Креирање/објава садржаја',
    'Trajno_korisnicko_ime': 'Трајно корисничко име',
    'Obavijesti_o_odgovorima': 'Обавијести о одговорима',
    'Sistemske_notifikacije': 'Системске нотификације',
    'Push_notifikacije': 'Push нотификације',
    'Prijavite_se': 'Пријава',
    'max_velicina_slike': 'Максимална величина слике је',

    'grad_rs_pitanje_brisanje_clana': 'Да ли сте сигурни да желите избрисати одборника/градоначелника',
    'grad_rs_potvrda_brisanja_clana': 'Потврда брисања одборника/градоначелника',

    'grad_rs_clanovi_gradskog_vijeca': 'Профили / питања одборника - градоначелника',
    'grad_rs_lista_clanova_gradskog_vijeca': 'Листа профила одборника и градоначелника',
    'grad_rs_unos_novog_clana_gradskog_vijeca': 'Унос новог профила одборника/градоначелника',
    'grad_rs_izmjena_clana_gradskog_vijeca': 'Измјена профила одборника/градоначелника',
    'grad_rs_pitanje_clanu_gradskog_vijeca': 'Питање одборнику/градоначелнику',
    'grad_rs_clanovi_gradskog_opstinskog_vijeca': 'Одборници',
    'grad_rs_pitanja_clanu_gradskog_opstinskog_vijeca': 'Питања постављена одборницима',
    'grad_rs_pitanja_za_nacelnika': 'Питанја постављена градоначелнику',
    'grad_rs_pitanja_odgovori_vijecnika': 'Питања/одговори по одборницима/градоначелнику',
    'grad_rs_vrijeme_odgovora_vijecnika': 'Вријеме одговора и просјечно вријеме по одборницима/градоначелнику',
    'grad_rs_broj_pitanja_odgovora_po_clanu': 'Број питања по одборнику',
    'grad_rs_vrijeme_odgovora_po_clanu': 'Вријеме одзива/одговора по одборнику (у часовима)',
    'grad_rs_uspjesno_obrisan_clan': ' Одборник/градоначелник је успјешно обрисан',
    'grad_rs_broj_prisutnih_vijecnika': 'Број присутних одборника',
    'grad_rs_broj_odsutnih_vijecnika': 'Број одсутних одборника',
    'grad_rs_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Просјечно вријеме одговора по одборницима',
    'grad_rs_odaberite_clana_vijeca': 'Одаберите одборника/градоначелника',
    'grad_rs_broj_pitanja_odgovora_gradonacelnik': 'Број питања по градоначелнику',
    'grad_rs_broj_pitanja_odgovora_org': 'Број питања по организационој јединици',
    'grad_rs_vrijeme_odgovora_gradonacelnik': 'Вријеме одзива/одговора по градоначелнику (у часовима)',
    'grad_rs_vrijeme_odgovora_org': 'Вријеме одзива/одговора по организационој јединици (у часовима)',
    'grad_rs_prosjecno_vrijeme_odgovora_gradonacelnik': 'Просјечно вријеме одговора по градоначелнику',
    'grad_rs_prosjecno_vrijeme_odgovora_org': 'Просјечно вријеме одговора по организационој јединици',
    'grad_rs_gradonacelnik': 'Градоначелник',
    'grad_rs_odbornici': 'Одборници',

    'opstina_rs_pitanja_za_nacelnika': 'Питанја постављена начелнику',
    'opstina_rs_clanovi_gradskog_vijeca': 'Профили одборника и начелника',
    'opstina_rs_lista_clanova_gradskog_vijeca': 'Листа профила одборника и начелника',
    'opstina_rs_unos_novog_clana_gradskog_vijeca': 'Унос новог профила одборника/начелника',
    'opstina_rs_izmjena_clana_gradskog_vijeca': 'Измјена профила одборника/начелника',
    'opstina_rs_pitanje_clanu_gradskog_vijeca': 'Питање одборнику/начелнику',
    'opstina_rs_clanovi_gradskog_opstinskog_vijeca': 'Одборници',
    'opstina_rs_pitanja_clanu_gradskog_opstinskog_vijeca': 'Питања постављена одборницима',
    'opstina_rs_pitanja_odgovori_vijecnika': 'Питања/одговори по одборницима/начелнику',
    'opstina_rs_vrijeme_odgovora_vijecnika': 'Вријеме одговора и просјечно вријеме по одборницима/начелнику',
    'opstina_rs_broj_pitanja_odgovora_po_clanu': 'Број питања/одговора по одборнику',
    'opstina_rs_vrijeme_odgovora_po_clanu': 'Вријеме одзива/одговора по одборнику (у часовима)',
    'opstina_rs_pitanje_brisanje_clana': 'Да ли сте сигурни да желите избрисати одборника/начелника',
    'opstina_rs_potvrda_brisanja_clana': 'Потврда брисања одборника/начелника',
    'opstina_rs_uspjesno_obrisan_clan': ' Одборник/начелник је успјешно обрисан',
    'opstina_rs_broj_prisutnih_vijecnika': 'Број присутних одборника',
    'opstina_rs_broj_odsutnih_vijecnika': 'Број одсутник одборника',
    'opstina_rs_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Просјечно вријеме одговора по одборницима',
    'opstina_rs_odaberite_clana_vijeca': 'Одаберите одборника/начелника',
    'opstina_rs_broj_pitanja_odgovora_gradonacelnik': 'Број питања по градоначелнику',
    'opstina_rs_broj_pitanja_odgovora_org': 'Број питања по организационој јединици',
    'opstina_rs_vrijeme_odgovora_gradonacelnik': 'Вријеме одзива/одговора по начелнику (у часовима)',
    'opstina_rs_vrijeme_odgovora_org': 'Вријеме одзива/одговора по организационој јединици (у часовима)',
    'opstina_rs_prosjecno_vrijeme_odgovora_gradonacelnik': 'Просјечно вријеме одговора по начелнику',
    'opstina_rs_prosjecno_vrijeme_odgovora_org': 'Просјечно вријеме одговора по организационој јединици',
    'opstina_rs_gradonacelnik': 'Начелник',
    'opstina_rs_odbornici': 'Одборници',

    'grad_fbih_pitanja_za_nacelnika': 'Питања поставлјена градоначелнику',
    'grad_fbih_clanovi_gradskog_vijeca': 'Профили вијећника и градоначелника',
    'grad_fbih_lista_clanova_gradskog_vijeca': 'Листа профила вијећника и градоначелника',
    'grad_fbih_unos_novog_clana_gradskog_vijeca': 'Унос новог профила вијећника/градоначелника',
    'grad_fbih_izmjena_clana_gradskog_vijeca': 'Измјена профила вијећника/градоначеника',
    'grad_fbih_pitanje_clanu_gradskog_vijeca': 'Питање вијећнику/градоначелнику',
    'grad_fbih_clanovi_gradskog_opstinskog_vijeca': 'Вијећници/градоначелник',
    'grad_fbih_pitanja_clanu_gradskog_opstinskog_vijeca': 'Питања постављена вијећницима/градоначелнику',
    'grad_fbih_pitanja_odgovori_vijecnika': 'Питања/одговори по вијећницима/градоначелику',
    'grad_fbih_vrijeme_odgovora_vijecnika': 'Вријеме одговора и просјечно вријеме по вијећницима/градоначелнику',
    'grad_fbih_broj_pitanja_odgovora_po_clanu': 'Број питања/одговора по вијећнику',
    'grad_fbih_vrijeme_odgovora_po_clanu': 'Вријеме одзива/одговора по вијећнику (у часовима)',
    'grad_fbih_pitanje_brisanje_clana': 'Да ли сте сигурни да желите избрисати вијећника/градоначелника',
    'grad_fbih_potvrda_brisanja_clana': 'Потврда брисања вијећника/градоначелника',
    'grad_fbih_uspjesno_obrisan_clan': 'Вијећник/градоначелник је успјешно обрисан',
    'grad_fbih_broj_prisutnih_vijecnika': 'Број присутних вијећника',
    'grad_fbih_broj_odsutnih_vijecnika': 'Број одсутних вијећника',
    'grad_fbih_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Просјечно вријеме одговора по вијећницима',
    'grad_fbih_odaberite_clana_vijeca': 'Одаберите вијећника/градоначелника',
    'grad_fbih_broj_pitanja_odgovora_gradonacelnik': 'Број питања по градоначелнику',
    'grad_fbih_broj_pitanja_odgovora_org': 'Број питања по организационој јединици',
    'grad_fbih_vrijeme_odgovora_gradonacelnik': 'Вријеме одзива/одговора по градоначелнику (у часовима)',
    'grad_fbih_vrijeme_odgovora_org': 'Вријеме одзива/одговора по организационој јединици (у часовима)',
    'grad_fbih_prosjecno_vrijeme_odgovora_gradonacelnik': 'Просјечно вријеме одговора по градоначелнику',
    'grad_fbih_prosjecno_vrijeme_odgovora_org': 'Просјечно вријеме одговора по организационој јединици',
    'grad_fbih_gradonacelnik': 'Градоначелник',
    'grad_fbih_odbornici': 'Вијећници',

    'opstina_fbih_pitanja_za_nacelnika': 'Питања поставлјена начелнику',
    'opstina_fbih_clanovi_gradskog_vijeca': 'Профили вијећника и начелника',
    'opstina_fbih_lista_clanova_gradskog_vijeca': 'Листа профила вијећника и начелника',
    'opstina_fbih_unos_novog_clana_gradskog_vijeca': 'Унос новог профила вијећника/начелника',
    'opstina_fbih_izmjena_clana_gradskog_vijeca': 'Измјена профила вијећника/начелника',
    'opstina_fbih_pitanje_clanu_gradskog_vijeca': 'Питање вијећнику/начелнику',
    'opstina_fbih_clanovi_gradskog_opstinskog_vijeca': 'Вијећници/начелник',
    'opstina_fbih_pitanja_clanu_gradskog_opstinskog_vijeca': 'Питања постављена вијећницима/начелнику',
    'opstina_fbih_pitanja_odgovori_vijecnika': 'Питања/одговори по вијећницима/начелнику',
    'opstina_fbih_vrijeme_odgovora_vijecnika': 'Вријеме одговора и просјечно вријеме по вијећницима/начелнику',
    'opstina_fbih_broj_pitanja_odgovora_po_clanu': 'Број питања/одговора по вијећнику',
    'opstina_fbih_vrijeme_odgovora_po_clanu': 'Вријеме одзива/одговора по вијећнику (у часовима)',
    'opstina_fbih_pitanje_brisanje_clana': 'Да ли сте сигурни да желите избрисати вијећника/начелника',
    'opstina_fbih_potvrda_brisanja_clana': 'Потврда брисања вијећника/начелника',
    'opstina_fbih_uspjesno_obrisan_clan': 'Вијећник/начелник је успјешно обрисан',
    'opstina_fbih_broj_prisutnih_vijecnika': 'Број пристуних вијећника',
    'opstina_fbih_broj_odsutnih_vijecnika': 'Број одсутних вијећника',
    'opstina_fbih_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Просјечно вријеме одговора по вијећницима',
    'opstina_fbih_odaberite_clana_vijeca': 'Одаберите вијећника/начелника',
    'opstina_fbih_broj_pitanja_odgovora_gradonacelnik': 'Број питања по начелнику',
    'opstina_fbih_broj_pitanja_odgovora_org': 'Број питања по организационој јединици',
    'opstina_fbih_vrijeme_odgovora_gradonacelnik': 'Вријеме одзива/одговора по начелнику (у часовима)',
    'opstina_fbih_vrijeme_odgovora_org': 'Вријеме одзива/одговора по организационој јединици (у часовима)',
    'opstina_fbih_prosjecno_vrijeme_odgovora_gradonacelnik': 'Просјечно вријеме одговора по начелнику',
    'opstina_fbih_prosjecno_vrijeme_odgovora_org': 'Просјечно вријеме одговора по организационој јединици',
    'opstina_fbih_gradonacelnik': 'Начелник',
    'opstina_fbih_odbornici': 'Вијећници',

    'ankete': 'Анкете',
    'lista_anketa': 'Листа анкета',
    'kod_ankete': 'Код',
    'naslov_ankete': 'Наслов',
    'datum_kreiranja_ankete': 'Датум креирања',
    'datum_zavrsetka_ankete': 'Датум завршетка анкете',
    'tip_ankete': 'Тип',
    'kategorija_ankete': 'Категорија',
    'vrsta_ucesnika_ankete': 'Врста учесника',
    'status_ankete': 'Статус',
    'anketa_vazi_od': 'Важи од',
    'anketa_vazi_do': 'Важи до',
    'kod_ankete_obavezan': 'Код анкете је обавезан',
    'naslov_ankete_obavezan': 'Наслов анкете је обавезан',
    'tip_ankete_obavezan': 'Тип анкете је обавезан',
    'kategorija_ankete_obavezna': 'Категорија анкете је обавезна',
    'tip_ucesnika_ankete_obavezan': 'Врста учесника анкете је обавезна',
    'status_ankete_obavezan': 'Статус анкете је обавезан',
    'status_ankete_azuriran': 'Статус анкете је ажуриран',
    'pocetni_datum_vazenja_ankete_obavezan': 'Почетни датум важења анкете је обавезан',
    'krajnji_datum_vazenja_ankete_obavezan': 'Крајњи датум важења анкете је обавезан',
    'unos_nove_ankete': 'Унос нове анкете',
    'izmjena_ankete': 'Измјена анкете',
    'detalji_ankete': 'Детаљи анкете',
    'tip_pitanja': 'Тип питања',
    'zakljucano': 'Закључано',
    'unos_novog_pitanja': 'Унос новог питања',
    'ponudjeni_odgovori': 'Понуђени одговори',
    'ponudjeni_odgovor': 'Понуђени одговор',
    'ponudjene_opcije_odgovora': 'Понуђене опције одговора',
    'tekst_opcije_odgovora': 'Текст опције одговора',
    'unos_ponudjenog_odgovora': 'Унос понуђеног одговора',
    'izmjena_ponudjenog_odgovora': 'Измјена понуђеног одогвора',
    'unos_opcije_ponudjenog_odgovora': 'Унос опције понуђеног одговора',
    'izmjena_opcije_ponudjenog_odgovora': 'Измјена опције понуђеног одговора',
    'ponudjena_opcija_odgovora': 'Понуђена опција одговора',
    'ucesnici_ankete': 'Учесници анкете',
    'izmijeni': 'Измијени',
    'izmjena_ucesnika_ankete': 'Измјена учесника анкете',
    'osnovni_podaci_ankete': 'Основни подаци анкете',
    'tip_pitanja_obavezan': 'Тип питања је обавезан',
    'upozorenje_dodajte_pitanja': 'Додајте питања. Анкета неће моћи бити објављена уколико не постоје питања.',
    'upozorenje_odaberite_ucesnike': 'Одаберите учеснике анкете. Анкета неће моћи бити објављена уколико нису одабрани учесници.',
    'upozorenje_dodajte_ponudjenje_odgovore': 'Додајте понуђене одговоре. Питање неће моћи бити објављено уколико не постоје понуђени одговори.',
    'objavi_anketu': 'Објави анкету',
    'objava_ankete': 'Објава анкете',
    'pregled_ankete': 'Преглед анкете',
    'krajnji_datum_mora_biti_veci_od_pocetnog': 'Крајњи датум важења анкете мора бити већи од почетног',
    'rezultati_ankete': 'Резултати анкете',
    'obrisi_anketu': 'Обриши анкету',
    'potvrda_brisanja_ankete': 'Брисање анкете',
    'pitanje_brisanje_ankete': 'Да ли сте сигурни да желите обрисати анкету',
    'anketa_uspjesno_obrisana': 'Анкета успјешно обрисана',
    'potvrda_brisanja_pitanja_ankete': 'Брисање питања анкете',
    'pitanje_brisanje_pitanja_ankete': 'Да ли сте сигурни да желите обрисати питање',
    'pitanje_ankete_uspjesno_obrisano': 'Питање успјешно обрисано',
    'potvrda_brisanja_ponudjenog_odgovora': 'Брисање понуђеног одговора',
    'pitanje_brisanje_ponudjenog_odgovora': 'Да ли сте сигурни да желите обрисати понуђени одговор',
    'ponudjeni_odgovor_uspjesno_obrisan': 'Понуђени одговор успјешно обрисан',
    'master_anketa': 'Мастер анкета',
    'sms_verifikacija_obavezna': 'SMS верификација корисника обавезна',
    'ukljuceno_slanje_podsjetnika': 'Укључено слање подсјетника',
    'osjetljiva_kategorija_obavezna': 'Одабир осјетљиве кат. обавезан',
    'primatelji_sistemske_notifikacije': 'Примаоци системске нотификације',
    'dodajte_ponudjene_odgovore': 'Додајте понуђене одговоре на питање',
    'dodajte_ponudjene_odgovore_i_opcije': 'Додајте понуђене одговоре на питање, као и понуђене опције одговора',
    'generisi_qr_kod': 'Генериши QR код анкете',
    'generisi_link_ankete': 'Генериши линк анкете',
    'link_ankete_naslov': 'Линк анкете',
    'sacuvano': 'Сачувано',
    'anketa_objavljena': 'Анкета објављена',
    'napomena_kreiranje_ankete': 'Кликом на дугме Сачувај систем ће послати обавјештење о креирању анкете службеницима који су означени као примаоци обавјештења.',
    'napomena_objava_ankete_1': 'Кликом на дугме Објави систем ће аутоматски додати датуме важења и промијити статус анкете у модулу Мастер анкете.',
    'napomena_objava_ankete_2': 'Систем ће послати обавјештење о објављивању анкете учесницима анкете, као и службеницима који су означени као примаоци обавјештења.',
    'objavi': 'Објави',
    'azuriraj_status': 'Ажурирај статус',
    'treba_azurirati_status': 'Статус анкете у модулу Мастер анкете није ажуриран',
    'sinhronizuj_anketu': 'Синхронизуј анкету',
    'anketa_sinhronizovana': 'Анкета синхронизована',
    'kopiraj_link': 'Копирај линк',
    'link_ankete_kopiran': 'Линк анкете успјешно копиран',
    'sve_ankete': 'Све анкете',
    'ukupno_ispunjeno': 'Укупно испуњено',
    'ukupno': 'Укупно',
    'административне_процедуре': 'Административне процедуре',
    'правни_лијекови': 'Правни лијекови',
    'листа_правних_лијекова': 'Листа правних лијекова',
    'registar_upravnih_postupaka': 'Регистар административних процедура',
    'lista_zivotnih_tema': 'Листа животних тема',
    'objavljeno': 'Објављено',
    'naziv_zivotne_teme': 'Назив животне теме',
    'detalji_zivotne_teme': 'Детаљи животне теме',
    'podteme': 'Подтеме',
    'naziv_podteme': 'Назив подтеме',
    'detalji_zivotne_podteme': 'Детаљи животне подтеме',
    'naziv_zivotne_podteme': 'Назив животне подтеме',
    'zivotna_tema': 'Животна тема',
    'upravni_postupci': 'Административне процедуре',
    'naziv_upravnog_postupka': 'Назив административне процедуре',
    'e_usluge_informacije': 'Информације о услугамо електронске управе. Услуге су подијељене на оне за које мозете преузети електронске обрасце и оне за које можете захтјев за услугу поднијети електронски уколико се пријавите на кориснички дио портала. Сервиси су подијељени по животним темама.',
    'e_usluge_link': 'Регистар административних процедура/еУслуга',
    'e_usluge_podkategorija_link': 'Подкатегорије',
    'e_usluge_detalji_link': 'Детаљи о услузи',
    'e_usluge_za_gradane': 'еУслуге за грађане',
    'unos_novog_upravnog_postupka': 'Нова административна процедура',

    'nadlezna_visa_org_jedinica': 'Надлежна виша организациона јединица',
    'nadlezna_niza_org_jedinica': 'Надлежна нижа организациона јединица',
    'nadlezna_org_jedinica': 'Надлежна организациона јединица',
    'kontakt_osobe': 'Контакт особе',
    'ime_i_prezime': 'Име и презиме',
    'pozicija': 'Позиција',
    'kontakt_telefon': 'Контакт телефон',
    'kontakt_email': 'Контакт емаил',
    'pravni_osnov': 'Правни основ',
    'taksa_naknada': 'Такса/Накнада',
    'naziv_takse': 'Назив таксе',
    'iznos': 'Износ',
    'broj_racuna': 'Број рачуна',
    'poziv_na_broj': 'Позив на број',
    'potrebna_dokumentacija': 'Потребна документација',
    'trazeni_dokument': 'Тражени документ',
    'institucija_koja_izdaje': 'Институција која издаје',
    'forma_dostave': 'Форма доставе',
    'komentar': 'Коментар',
    'instrukcije_korak_po_korak': 'Инструкције корак по корак',
    'tekst': 'Текст',
    'korisni_linkovi': 'Корисни линкови',
    'opis': 'Опис',
    'url': 'URL',
    'upravni_postupak_dostupan_u_elektronskoj_formi': 'Административна процедура доступна у електронској форми',
    'dokumenti': 'Документи',
    'naziv': 'Назив',
    'na_koga_se_odnosi_usluga': 'На кога се односи услуга',
    'tip_usluge': 'Тип услуге',
    'status_usluge': 'Статус услуге',
    'nivo_sofisticiranosti': 'Ниво софистицираности',
    'kriterijum': 'Критеријум',
    'izlazni_rezultat': 'Излазни резултат',
    'izlazni_rezultat_obavezan': 'Излазни резултат је обавезан',
    'pravni_lijek': 'Правни лијек',
    'pravni_lijek_obavezan': 'Правни лијек је обавезан',
    'rok_za_rjesavanje': 'Рок за рјешавање (дана)',
    'vrijeme_vazenja_odluke': 'Вријеме важења одлуке',
    'nadleznost_izvornog_registra': 'Надлежност изворног регистра',
    'kod_je_obavezan': 'Код је обавезан',
    'naziv_upravnog_postupka_obavezan': 'Назив административне процедуре је обавезан',
    'opis_upravnog_postupka_obavezan': 'Опис административне процедуре је обавезан',
    'nadlezna_visa_org_jedinica_obavezna': 'Надлежна виша организациона јединица је обавезна',
    'nadlezna_niza_org_jedinica_obavezna': 'Надлежна нижа организациона јединица је обавезна',
    'nadlezna_org_jedinica_obavezna': 'Надлежна организациона јединица је обавезна',
    'pravni_osnov_obavezan': 'Правни основ је обавезан',
    'na_koga_se_odnosi_usluga_obavezno': 'На кога се односи услуга је обавезно',
    'tip_usluge_obavezan': 'Тип услуге је обавезан',
    'status_usluge_obavezan': 'Статус услуге је обавезан',
    'nivo_sofisticiranosti_obavezan': 'Ниво софистицираности је обавезан',
    'kriterijum_obavezan': 'Критеријум је обавезан',
    'rok_za_rjesavaje_obavezan': 'Рок за рјешавање је обавезан',
    'vrijeme_vazenja_odluke_obavezno': 'Вријеме важења одлуке је обавезно',
    'ime_i_prezime_obavezno': 'Име и презиме је обавезно',
    'pozicija_obavezna': 'Позиција је обавезна',
    'iznos_obavezan': 'Износ је обавезан',
    'broj_racuna_obavezan': 'Број рачуна је обавезан',
    'poziv_na_broj_obavezan': 'Позив на број је обавезан',
    'trazeni_dokument_obavezan': 'Тражени документ је обавезан',
    'institucija_obavezna': 'Институција је обавезна',
    'forma_dostave_obavezno': 'Форма доставе је обавезна',
    'kontakt_osoba_obavezna': 'Контакт особа је обавезна',
    'instrukcije_obavezne': 'Инструкције су обавезне',
    'nedozvoljeno_brisanje_kategorije_sa_potkategorijom': 'Одабрана категорија у себи садржи поткатегорије. Молимо избришите прво поткатегорије',
    'nedozvoljeno_brisanje_potkategorije_sa_procedurama': 'Одабрана категорија у себи садржи административне процедуре. Молимо избришите прво процедуре.',
    'odabir_clana_modal': 'Одабир члана вијећа/начелника/градоначелника',
    'rekreiraj_anketu': 'Копирај анкету',
    'bazna_anketa': 'Базна анкета',
    'rekreiranje_ankete': 'Копирање анкете',
    'anketa_uspjesno_kopirana': 'Анкета успјешно копирана',
    'trajno_brisanje_profila_checkbox': 'Трајно брисање профила',
    'trajno_brisanje_profila_napomena': 'Означавање "Трајно брисање профила" Ваш кориснички профил и подаци о профилу ће бити трајно избрисни из сустава еЦитизен-а.',
    'anketa_spremljena' : 'Анкета је спремљена',
    'izmijena_statusa_rijesena' : 'Није могуће ажуритати статус ријешене притужбе',
    'naziv_kategorije' : 'Назив категорије',
    'naziv_podkategorije' : 'Назив подкатегорије',
    'detalji_kategorije' : 'Детаљи категорије',
    'detalji_podkategorije' : 'Детаљи подкатегорије',
    'nedozvoljen_format_slike' : 'Недозвољен формат слике. Дозвољени формати: jpg, jpeg, png, bmp, webp',
    'saziv_ne_postoji_ili_neaktivan': 'Сазив није тренутни или је неактиван',
    'vijecnik_postoji': 'Одабрани корисник већ постоји као вијећник/градоначеник',
}